"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const TileGroupLoadMoreButton = React.memo(({ isExpanded, labelMore, labelLess, tileGroupId, onLoadMoreButtonClick }) => {
    const url = React.useMemo(() => {
        if (isExpanded) {
            return '/';
        }
        return `${tileGroupId}=expanded`;
    }, [isExpanded, tileGroupId]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex justify-center mt-2xl mb-5xl", children: (0, jsx_runtime_1.jsx)("a", { href: url, className: "btn-secondary btn-large no-underline w-full sm:w-auto", rel: isExpanded ? 'prev' : 'next', onClick: onLoadMoreButtonClick, children: (0, jsx_runtime_1.jsx)("span", { className: "text-nowrap", children: isExpanded ? labelLess : labelMore }) }) }));
});
exports.default = TileGroupLoadMoreButton;
